'use strict';

/** @type {import('./maxArrayLength')} */
module.exports = 4294967295; // Math.pow(2, 32) - 1;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/constants/maxArrayLength.js
// module id = 1466
// module chunks = 4